import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import { NewsPaperVendorData } from "../../../FetchAPI";
import { useAuth } from "../../../../Store/AuthContext";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import Sidebar from "../../Sidebar";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import { Helmet } from "react-helmet";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function NewsPaperScheduleEdit() {
  let { newsid } = useParams();

  const { userID, RendomTokenfetch } = useAuth();

  const [NewsVendorData] = NewsPaperVendorData(RendomTokenfetch, newsid);
  // console.log(NewsVendorData);
  const navigate = useNavigate();

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // const [error, setError] = useState({});
  const newsvendorstatus = [
    { id: "0", title: "Reject" },
    { id: "2", title: "Pending" },
  ];

  // console.log(newsvendorstatus);
  // Refs for all inputs
  const vendorQuotation = useRef(NewsVendorData?.vendor_amount || "");
  const vendorDesc = useRef(NewsVendorData?.vender_description || "");
  const [vendorstatus, setvendorstatus] = useState("0");
  // const vendorstatus = useRef(NewsVendorData?.vender_status || "");S

  useEffect(() => {
    if (NewsVendorData?.vender_statusid !== undefined) {
      setvendorstatus(String(NewsVendorData.vender_statusid));
    }
  }, [NewsVendorData]);

  // Handle On Form Submit
  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("news_id", newsid);
    fdata.append("cuotation", vendorQuotation.current.value);
    fdata.append("description", vendorDesc.current.value);
    fdata.append("vendor_status", vendorstatus);

    axios
      .post(`${WebsiteAPIurl}vendorNewsUpdate`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (vendorstatus) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.message, "danger", true);
            // setError(ProfileEditValidation(response.data.form_validation));
          }
          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.message, "success", true);
            navigate(`/news-paper-schedule`);
          }
        } else {
          // console.log(response.data);
          // setError(ProfileEditValidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "News Paper Schedule", pagelink: "news-paper-schedule" },
            { name: "Edit" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content py-4">
                      <form
                        className="was-validated"
                        onSubmit={handleSubmit}
                        encType="multipart/form-data"
                      >
                        <div className="row">
                          <div className="form-group col-lg-12 col-md-12 mb-2">
                            <label>
                              Vendor Description
                              <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows="4"
                              ref={vendorDesc}
                              defaultValue={stripHtml(
                                NewsVendorData?.vender_description || ""
                              )}
                              required
                            />
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Vendor Quotation
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              ref={vendorQuotation}
                              defaultValue={NewsVendorData?.vendor_amount || ""}
                              
                            />
                          </div>
                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Vendor Request Status
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={vendorstatus}
                              onChange={(e) => setvendorstatus(e.target.value)}
                              required
                            >
                              {newsvendorstatus &&
                                newsvendorstatus.map((valStatus) => (
                                  <option
                                    value={valStatus.id}
                                    key={valStatus.id}
                                  >
                                    {valStatus.title}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-12 col-md-12 text-center mt-3">
                            <button
                              className="AllsiteButton mt-2"
                              type="submit"
                              name="submit"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
